import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import * as R from 'ramda';

import {List as DXList} from 'devextreme-react';


export default class List extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allowDeleting: this.props.allowDeleting,
            deleteType: this.props.deleteType,
            selectedItems: this.props.selectedItems || [],
            selectedItem: null,
            dataSource: this.props.dataSource,
            items: this.props.items,
            // visible: this.props.visible,
        };

        this.groupTemplate = this.groupTemplate.bind(this);
        this.itemTemplate = this.itemTemplate.bind(this);
        this.onOptionChanged = this.onOptionChanged.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.onItemReordered = this.onItemReordered.bind(this);
        this.onItemRendered = this.onItemRendered.bind(this);
        this.onItemHold = this.onItemHold.bind(this);
        this.onDragChange = this.onDragChange.bind(this);
    }

    // UNSAFE_componentWillReceiveProps(props) {
    //     // console.log('componentWillReceiveProps', this.props.rowDragging.data, props);
    //     // if (!R.equals(this.state.dataSource, props.dataSource)) {
    //     if (this.state.items !== props.items) {
    //         // console.log('componentWillReceiveProps no equals', this.props.rowDragging.data, this.state.dataSource);
    //         // console.log('componentWillReceiveProps no equals', this.props.rowDragging.data, props.dataSource);
    //         this.setState({
    //             items: props.items,
    //         });
    //     }
    //     if (this.state.visible !== props.visible) {
    //         this.setState({visible: props.visible});
    //     }
    // }

    onOptionChanged(args) {
        if(args.name === 'selectedItems') {
            this.setState({
                selectedItems: args.value
            });
        }
    }

    onItemClick(e) {
        this.setState({
            selectedItem: e.itemData
        });
    }

    groupTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            ReactDOM.render(tmpl(itemData), element);
        }
    }

    itemTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            ReactDOM.render(tmpl(itemData), element);
        }
    }

    onDragStart(e) {
        console.log('onDragStart', e)
        console.log('onDragStart selectedItems', this.state.selectedItem)
        console.log('onDragStart dataSource', this.state.dataSource)
        e.itemData = (this.state.items || this.state.dataSource.store)[e.fromIndex];
    }

    onAdd(e) {
        console.log('onAdd', e)
        const tasks = this.state.items || this.state.dataSource.store;
        const t = [...tasks.slice(0, e.toIndex), e.itemData, ...tasks.slice(e.toIndex)];
        if (this.state.items)
            this.setState({
                items: t
            });
        else {
            this.setState({
                dataSource: {
                    ...this.state.dataSource,
                    store: t
                }
            });
        }

    }

    onRemove(e) {
        console.log('onRemove', e)
        const tasks = this.state.items || this.state.dataSource.store;
        const t = [...tasks.slice(0, e.fromIndex), ...tasks.slice(e.fromIndex + 1)];
        if (this.state.items)
            this.setState({
                items: t
            });
        else {
            this.setState({
                dataSource: {
                    ...this.state.dataSource,
                    store: t
                }
            });
        }
    }

    onDragChange(e) {
        console.log('onDragChange', e)

        let visibleRows = e.component.getVisibleRows();
        console.log('onDragChange visibleRows', visibleRows)
        let sourceNode = e.component.getNodeByKey(e.itemData.ID);
        console.log('onDragChange sourceNode', sourceNode)
        let targetNode = visibleRows[e.toIndex].node;
        console.log('onDragChange targetNode', targetNode)

        // while (targetNode && targetNode.data) {
        //     if (targetNode.data.ID === sourceNode.data.ID) {
        //         e.cancel = true;
        //         break;
        //     }
        //     targetNode = targetNode.parent;
        // }
    }

    onItemHold(e) {
        console.log('onItemHold', e)
        e.dataIndex = e.itemIndex;
    }

    onItemRendered(e) {
        console.log('onItemRendered', e)

    }

    onItemReordered(e) {
        console.log('onItemReordered', e)
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }

        let {groupTemplate, itemTemplate} = this.props;

        if (groupTemplate && typeof groupTemplate === 'string' && groupTemplate !== 'group'){
            groupTemplate = this.groupTemplate(groupTemplate);
        }

        if (itemTemplate && typeof itemTemplate === 'string' && itemTemplate !== 'item'){
            itemTemplate = this.itemTemplate(itemTemplate);
        }

        const itemDragging = this.props.itemDragging || {};
        itemDragging.onDragStart = this.onDragStart;
        itemDragging.onAdd = this.onAdd;
        itemDragging.onRemove = this.onRemove;
        // itemDragging.onDragChange = this.onDragChange;

        return (
            <DXList
                {...R.omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                items={this.state.items}
                dataSource={this.state.dataSource}
                // visible={this.state.visible}
                itemDragging={itemDragging}
                groupTemplate={groupTemplate}
                itemTemplate={itemTemplate}
                selectedItems={this.state.selectedItems}
                onOptionChanged={this.props.onOptionChanged || this.onOptionChanged}
                onItemClick={this.props.onItemClick || this.onItemClick}
                onItemReordered={this.props.onItemReordered || this.onItemReordered}
                // onItemRendered={this.props. onItemRendered || this. onItemRendered}
                // onItemHold={this.props. onItemHold || this. onItemHold}
            />
        );
    }
}

List.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * Specifies whether or not the UI component changes its state when interacting with a user
     */
    activeStateEnabled: PropTypes.bool,
    /**
     * Specifies whether or not an end user can delete list items
     */
    allowItemDeleting: PropTypes.bool,
    /**
     * A Boolean value specifying whether to enable or disable the bounce-back effect
     */
    bounceEnabled: PropTypes.bool,
    /**
     * Specifies whether or not an end-user can collapse groups
     */
    collapsibleGroups: PropTypes.bool,
    /**
     * Binds the UI component to data
     */
    dataSource: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.arrayOf(PropTypes.any)]),
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the data field whose values should be displayed. Defaults to "text" when the data source contains objects
     */
    displayExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies whether the UI component can be focused using keyboard navigation
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * An alias for the groupTemplate property specified in React. Accepts a custom component.
     */
    groupComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * Specifies whether data items should be grouped
     */
    grouped: PropTypes.bool,
    /**
     * An alias for the groupTemplate property specified in React. Accepts a rendering function.
     */
    groupRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies a custom template for group captions
     */
    groupTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * Specifies whether or not to show the loading panel when the DataSource bound to the UI component is loading data
     */
    indicateLoading: PropTypes.bool,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a custom component.
     */
    itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * Specifies the way a user can delete items from the list
     */
    itemDeleteMode: PropTypes.oneOf(['context', 'slideButton', 'slideItem', 'static', 'swipe', 'toggle']),
    /**
     * Configures item reordering using drag and drop gestures
     */
    itemDragging: PropTypes.object,
    /**
     * The time period in milliseconds before the onItemHold event is raised
     */
    itemHoldTimeout: PropTypes.number,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a rendering function.
     */
    itemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * An array of items displayed by the UI component
     */
    items: PropTypes.arrayOf(PropTypes.any),
    /**
     * Specifies a custom template for items
     */
    itemTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies the key property that provides key values to access data items. Each key value must be unique.
     */
    keyExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies the array of items for a context menu called for a list item
     */
    menuItems: PropTypes.arrayOf(PropTypes.object),
    /**
     * Specifies whether an item context menu is shown when a user holds or swipes an item
     */
    menuMode: PropTypes.oneOf(['context', 'slide']),
    /**
     * The text displayed on the button used to load the next page from the data source
     */
    nextButtonText: PropTypes.string,
    /**
     * The text or HTML markup displayed by the UI component if the item collection is empty
     */
    noDataText: PropTypes.string,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function that is executed when a group element is rendered
     */
    onGroupRendered: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed when a collection item is clicked or tapped
     */
    onItemClick: PropTypes.func,
    /**
     * A function that is executed when a collection item is right-clicked or pressed
     */
    onItemContextMenu: PropTypes.func,
    /**
     * A function that is executed after a list item is deleted from the data source
     */
    onItemDeleted: PropTypes.func,
    /**
     * A function that is executed before a collection item is deleted from the data source
     */
    onItemDeleting: PropTypes.func,
    /**
     * A function that is executed when a collection item has been held for a specified period
     */
    onItemHold: PropTypes.func,
    /**
     * A function that is executed after a collection item is rendered
     */
    onItemRendered: PropTypes.func,
    /**
     * A function that is executed after a list item is moved to another position
     */
    onItemReordered: PropTypes.func,
    /**
     * A function that is executed when a list item is swiped
     */
    onItemSwipe: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed before the next page is loaded
     */
    onPageLoading: PropTypes.func,
    /**
     * A function that is executed when the "pull to refresh" gesture is performed. Supported in mobile themes only
     */
    onPullRefresh: PropTypes.func,
    /**
     * A function that is executed on each scroll gesture
     */
    onScroll: PropTypes.func,
    /**
     * A function that is executed when the "Select All" check box value is changed. Applies only if the selectionMode is "all".
     */
    onSelectAllValueChanged: PropTypes.func,
    /**
     * A function that is executed when a collection item is selected or selection is canceled
     */
    onSelectionChanged: PropTypes.func,
    /**
     * Specifies the text shown in the pullDown panel, which is displayed when the list is scrolled to the bottom
     */
    pageLoadingText: PropTypes.string,
    /**
     * Specifies whether the next page is loaded when a user scrolls the UI component to the bottom or when the "next" button is clicked
     */
    pageLoadMode: PropTypes.oneOf(['nextButton', 'scrollBottom']),
    /**
     * Specifies the text displayed in the pullDown panel when the list is pulled below the refresh threshold
     */
    pulledDownText: PropTypes.string,
    /**
     * Specifies the text shown in the pullDown panel while the list is being pulled down to the refresh threshold
     */
    pullingDownText: PropTypes.string,
    /**
     * A Boolean value specifying whether or not the UI component supports the "pull down to refresh" gesture
     */
    pullRefreshEnabled: PropTypes.bool,
    /**
     * Specifies the text displayed in the pullDown panel while the list is being refreshed
     */
    refreshingText: PropTypes.string,
    /**
     * Specifies whether to repaint only those elements whose data changed
     */
    repaintChangesOnly: PropTypes.bool,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * A Boolean value specifying if the list is scrolled by content
     */
    scrollByContent: PropTypes.bool,
    /**
     * A Boolean value specifying if the list is scrolled using the scrollbar
     */
    scrollByThumb: PropTypes.bool,
    /**
     * A Boolean value specifying whether to enable or disable list scrolling
     */
    scrollingEnabled: PropTypes.bool,
    /**
     * Configures the search panel
     */
    searchEditorOptions: PropTypes.object,
    /**
     * Specifies whether the search panel is visible
     */
    searchEnabled: PropTypes.bool,
    /**
     * Specifies a data object's field name or an expression whose value is compared to the search string
     */
    searchExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    /**
     * Specifies a comparison operation used to search UI component items
     */
    searchMode: PropTypes.oneOf(['contains', 'startswith', 'equals']),
    /**
     * Specifies a delay in milliseconds between when a user finishes typing, and the search is executed
     */
    searchTimeout: PropTypes.number,
    /**
     * Specifies the current search string
     */
    searchValue: PropTypes.string,
    /**
     * Specifies the mode in which all items are selected
     */
    selectAllMode: PropTypes.oneOf(['allPages', 'page']),
    /**
     * Specifies an array of currently selected item keys
     */
    selectedItemKeys: PropTypes.arrayOf(PropTypes.any),
    /**
     * An array of currently selected item objects
     */
    selectedItems: PropTypes.arrayOf(PropTypes.any),
    /**
     * Specifies item selection mode
     */
    selectionMode: PropTypes.oneOf(['all', 'multiple', 'none', 'single']),
    /**
     * Specifies when the UI component shows the scrollbar
     */
    showScrollbar: PropTypes.oneOf(['always', 'never', 'onHover', 'onScroll']),
    /**
     * Specifies whether or not to display controls used to select list items
     */
    showSelectionControls: PropTypes.bool,
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * Specifies whether or not the UI component uses native scrolling
     */
    useNativeScrolling: PropTypes.bool,
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

List.defaultProps = {
    accessKey: null,
    activeStateEnabled: true,
    allowItemDeleting: false,
    bounceEnabled: false, // true, false (desktop)
    collapsibleGroups: false,
    dataSource: null,
    disabled: false,
    // displayExpr: undefined,
    elementAttr: {},
    focusStateEnabled: true,
    groupComponent: null,
    grouped: false,
    groupRender: null,
    groupTemplate: 'group',
    // height: undefined,
    // hint: undefined,
    hoverStateEnabled: true,
    indicateLoading: true,
    itemComponent: null,
    itemDeleteMode: 'static',
    // itemDragging
    itemHoldTimeout: 750,
    itemRender: null,
    items: null,
    itemTemplate: 'item',
    keyExpr: null,
    menuItems: [],
    menuMode: 'context',
    nextButtonText: 'More',
    noDataText: 'No data to display',
    onContentReady: null,
    onDisposing: null,
    onGroupRendered: null,
    onInitialized: null,
    onItemClick: null,
    onItemContextMenu: null,
    onItemDeleted: null,
    onItemDeleting: null,
    onItemHold: null,
    onItemRendered: null,
    onItemReordered: null,
    onItemSwipe: null,
    onOptionChanged: null,
    onPageLoading: null,
    onPullRefresh: null,
    onScroll: null,
    onSelectAllValueChanged: null,
    onSelectionChanged: null,
    pageLoadingText: 'Loading...', // '' (Material)
    pageLoadMode: 'nextButton', // 'scrollBottom', 'nextButton' (desktop except Mac)
    pulledDownText: 'Release to refresh...', // '' (Material)
    pullingDownText: 'Pull down to refresh...', // '' (Material)
    pullRefreshEnabled: false,
    refreshingText: 'Refreshing...', // '' (Material)
    repaintChangesOnly: false,
    rtlEnabled: false,
    scrollByContent: false, // true, false (non-touch devices)
    scrollByThumb: true, // false, true (desktop)
    scrollingEnabled: true,
    searchEditorOptions: {},
    searchEnabled: false,
    searchExpr: null,
    searchMode: 'contains',
    searchTimeout: 300,
    searchValue: '',
    selectAllMode: 'page',
    // selectedItemKeys
    // selectedItems
    selectionMode: 'none',
    showScrollbar: 'onHover', // 'onScroll', 'onHover' (desktop)
    showSelectionControls: false,
    tabIndex: 0,
    useNativeScrolling: false, // true, false (desktop except Mac)
    visible: true,
    // width: undefined
};
